module.exports = __webpack_public_path__ + "static/media/address.7fd812bc.svg";